import React, { FC } from "react";

import { Flair } from "../../../common/Flair";
import { Image } from "../../../common/Image";
import { BreakPoint } from "../../../models/screen";
import { useAppSelector } from "../../reducers";
import { tabFeatureAttributeBlock } from "../elementIDs";
import {
    ITabFeatureAttributeBlock_AttributeTab,
    ITabFeatureAttributeBlock_ModelTab,
} from "../models";

import styles from "./TabFeatureAttributeBlockModelTabImage.module.scss";

type TabFeatureAttributeBlockModelTabImageProps = {
    attrIdx: number;
    attrTab: ITabFeatureAttributeBlock_AttributeTab;
    modelIdx: number;
    modelTab: ITabFeatureAttributeBlock_ModelTab;
    isSelected: boolean;
};

export const TabFeatureAttributeBlockModelTabImage: FC<
    TabFeatureAttributeBlockModelTabImageProps
> = ({ attrIdx, attrTab, modelIdx, modelTab, isSelected }) => {
    const viewport = useAppSelector((state) => state.common.viewport);
    const imageUrl =
        viewport.width <= BreakPoint.SMALL && modelTab.image_mobile
            ? modelTab.image_mobile.url
            : modelTab.image.url;

    return (
        <article
            id={tabFeatureAttributeBlock.modelTabContent(
                attrTab,
                attrIdx,
                modelTab,
                modelIdx,
            )}
            role="tabpanel"
            tabIndex={0}
            aria-labelledby={tabFeatureAttributeBlock.modelTabButton(
                attrTab,
                attrIdx,
                modelTab,
                modelIdx,
            )}
            hidden={!isSelected}
        >
            {modelTab.flair?.content && (
                <div className={styles.flair}>
                    <Flair flair={modelTab.flair} inline={true} />
                </div>
            )}
            <div className={styles.image}>
                <Image src={imageUrl} className="responsive-img" />
            </div>
        </article>
    );
};
